import { InjectionToken } from '@angular/core';
export const ROUTER_NAVIGATION_INTERCEPTOR = /*#__PURE__*/new InjectionToken('ROUTER_NAVIGATION_INTERCEPTOR');